import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp, Stagger, StaggerItem } from "@/components/Reveal";
import { MATERIALS, MATERIAL_CATEGORIES, IMG_FALLBACK } from "@/lib/api";

const Products = () => (
  <div data-testid="products-page">
    <PageHero eyebrow="/ MATERIALS WE BUY" title={["Materials", "we buy."]}
      subtitle="We purchase post-industrial polymer, paper, PPE and packaging streams — non-prime, off-grade, regrind, repro and mixed loads — on recurring contracts across North America." />

    {MATERIAL_CATEGORIES.map((cat) => {
      const items = MATERIALS.filter((m) => m.category === cat);
      if (items.length === 0) return null;
      return (
        <section key={cat} className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20 border-b border-navy/10">
          <div className="font-mono text-xs tracking-[0.3em] text-emerald mb-3">/ {cat.toUpperCase()}</div>
          <FadeUp><h2 className="font-display font-black text-3xl md:text-4xl tracking-tighter text-navy mb-10">{cat}</h2></FadeUp>
          <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((m) => (
              <StaggerItem key={m.name}>
                <div className="group border border-navy/10 hover:border-emerald transition-colors" data-testid={`product-${m.name}`}>
                  <div className="relative overflow-hidden">
                    <img src={m.img} alt={m.name} onError={(e) => { e.currentTarget.src = IMG_FALLBACK; }}
                      className="w-full aspect-[4/3] object-cover group-hover:scale-105 transition-transform duration-500" />
                    <span className="absolute top-4 left-4 bg-emerald text-navy font-mono text-xs px-3 py-1 tracking-widest">{m.code}</span>
                  </div>
                  <div className="p-6">
                    <h3 className="font-display font-bold text-xl text-navy tracking-tight">{m.name}</h3>
                    <p className="text-navy/60 text-sm mt-2 leading-relaxed">{m.desc}</p>
                  </div>
                </div>
              </StaggerItem>
            ))}
          </Stagger>
        </section>
      );
    })}

    <section className="bg-offwhite py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-2 gap-12 items-center">
        <FadeUp>
          <div className="font-mono text-xs tracking-[0.3em] text-emerald mb-4">/ LOAD OPTIONS</div>
          <h2 className="font-display font-black text-4xl md:text-5xl tracking-tighter text-navy mb-6">Any volume, any mix.</h2>
          <p className="text-navy/70 text-lg leading-relaxed">
            Whether it's a container of clean regrind or a mixed truckload of production stock lots,
            we structure a recurring purchase and pickup program around your material stream —
            with placement into verified downstream buyers.
          </p>
          <Link to="/submit-offer" data-testid="products-cta"
            className="group mt-8 inline-flex bg-navy text-white font-mono text-xs uppercase tracking-widest px-7 py-4 items-center gap-2 hover:bg-emerald hover:text-navy transition-colors">
            Sell Your Material <ArrowRight size={16} />
          </Link>
        </FadeUp>
        <FadeUp delay={0.1}>
          <img src="/images/export-containers.png" alt="Export loads" className="w-full aspect-[4/3] object-cover" />
        </FadeUp>
      </div>
    </section>
  </div>
);

export default Products;
